export default __webpack_public_path__ + "static/media/white-ks.7e7e33cc.png";